import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBreadCrumbDataContext } from 'app/crumbs/context/useSetBreadCrumbData'
import { Breadcrumbs, Crumb } from '@carsys/ui'

const BaseProposalBreadCrumbs: React.FC<{ path: string; title: string; name: string }> = ({ path, title, name }) => {
  const { t } = useTranslation()
  const { breadCrumbData } = useBreadCrumbDataContext()

  return (
    <Breadcrumbs>
      <Crumb data-testid='crumb-appointment-proposals' path={path} text={t(title)} />
      {breadCrumbData.appointmentProposalEasyID && (
        <Crumb
          data-testid='crumb-appointment-proposals-detail'
          path={[`${path}/:proposalUUID/:step`, `${path}'/:proposalUUID`]}
          text={t(name, { id: breadCrumbData.appointmentProposalEasyID })}
        />
      )}
    </Breadcrumbs>
  )
}

const ProposalBreadCrumbs: React.FC = () => {
  return (
    <React.Fragment>
      <BaseProposalBreadCrumbs path='/intake/:intakeSource' title='intake.title' name='intake.breadcrumb' />
      <BaseProposalBreadCrumbs path='/proposal/:intakeSource' title='Proposal.Title' name='Proposal.BreadCrumbEdit' />
    </React.Fragment>
  )
}

export default ProposalBreadCrumbs
